module.exports = __webpack_public_path__ + "img/icon-contact.b1a6017b.svg";